import * as React from 'react';
import { Button, Container, Form } from 'semantic-ui-react';
import * as Detail from '~/InfoCard/Details';
export var PeriodButtons = function (_a) {
    var load = _a.load, yearMonth = _a.yearMonth;
    return (<Container fluid>
		<Form.Field>
			<Button compact data-testid='previous-records' icon='left chevron' labelPosition='left' size='tiny' onClick={function () {
            load(Detail.PeriodAction.PREVIOUS_PERIOD);
        }}>
				<i aria-hidden='true' className='left chevron icon'></i>Předchozí období
			</Button>
			<Button compact data-testid='next-records' disabled={yearMonth.getTime() > +new Date().valueOf()} icon='right chevron' labelPosition='right' size='tiny' onClick={function () {
            load(Detail.PeriodAction.NEXT_PERIOD);
        }}>
				<i aria-hidden='true' className='right chevron icon'/>
				Následující období
			</Button>
		</Form.Field>
	</Container>);
};
